import { Button } from "@mui/material";
import { ExcelIcon } from "./excel";
import { cmmsTheme } from "@setup/theme/cmms-theme";

export const ExcelButton = ({ onClick }: { onClick: () => void }) => {
	return (
		<Button
			variant="outlined"
			onClick={onClick}
			style={cmmsTheme.styles.excelButton}>
			<span
				style={{
					display: "inline-flex",
					alignItems: "center",
					gap: 8,
					lineHeight: 1,
				}}>
				<ExcelIcon />
				EXCEL
			</span>
		</Button>
	);
};
